module.exports = __webpack_public_path__ + "img/u3881.bdfb26dd.svg";